import React from "react";
import { Box, Typography } from "@mui/material";
import { useCompanyData } from '../../shared/contexts/DataContext';
import { textVariant, textClasses } from '../../shared/config';

function SectionTitle({ children, fontWeight, ...props }) {
  const { data } = useCompanyData();
  const { generalTitleFontSize, generalTitleColor } = data || {};
  const titleFontColor = props.color ? props?.color : generalTitleColor ? generalTitleColor : '#110729';

  const variant = props?.pFontSize && textVariant?.[props?.pFontSize] ? textVariant?.[props?.pFontSize] :
  generalTitleFontSize && textVariant?.[generalTitleFontSize] ? textVariant?.[generalTitleFontSize] : textVariant?.['62'];
  
  const fontSizeCls = props?.pFontSize && textClasses?.[props?.pFontSize] ? textClasses?.[props?.pFontSize] :
  generalTitleFontSize && textClasses?.[generalTitleFontSize] ? textClasses?.[generalTitleFontSize] : textClasses?.['62'];

  return (
    <Box
      pb={3}
      // fontWeight={fontWeight || 700}
      color={titleFontColor}
      position="relative"
      zIndex={2}
      {...props}
    >
      <Typography 
      variant={variant}
      className={fontSizeCls}
      style={{ textTransform: "capitalize",fontFamily:'inherit',fontWeight: fontWeight || 'inherit' }}>
        {children}
      </Typography>
    </Box>
  );
};

const SectionSubtitle = ({ children,pFontsize, ...props }) => {
  const  { visibleHorizontalLine=true } = props;
  const { data } = useCompanyData();
  const { generalSubTitleFontSize, generalSubTitleColor } = data || {};
  const subTitleFontColor = props.color ? props.color : generalSubTitleColor ? generalSubTitleColor : '#110729';
  const variant = props?.pFontSize && textVariant?.[props?.pFontSize] ? textVariant?.[props?.pFontSize] :
  generalSubTitleFontSize && textVariant?.[generalSubTitleFontSize] ? textVariant?.[generalSubTitleFontSize] : textVariant?.['18'];
  
  const fontSizeCls = props?.pFontSize && textClasses?.[props?.pFontSize] ? textClasses?.[props?.pFontSize] :
  generalSubTitleFontSize && textClasses?.[generalSubTitleFontSize] ? textClasses?.[generalSubTitleFontSize] : textClasses?.['18'];

  return (
    <Box
      position="relative"
      zIndex={2}
      pb={2}
      display="flex"
      alignItems="center"
      color={subTitleFontColor}
      textAlign="inherit"
      {...props}
    >
      {visibleHorizontalLine ? 
      <Box height="3px" width="60px" bgcolor={"#FAC400"} mx={1} />
       : null}
      <Typography
        variant={variant}
        className={fontSizeCls}
        style={{ fontWeight: 500,fontFamily:'inherit' }}>
        {children}
      </Typography>
    </Box>
  );
};

function SectionParagraph({ children, ...props }) {
  // const { data } = useCompanyData();
  // const [, , fontFamily] = useRTL('',"'Roboto', sans-serif");
  const { data } = useCompanyData();
  const { generalParagraphFontSize, generalParagraphColor } = data || {};
  const descFontColor = props.color ? props.color : generalParagraphColor ? generalParagraphColor : '#000';
  const variant = props?.pFontSize && textVariant?.[props?.pFontSize] ? textVariant?.[props?.pFontSize] :
  generalParagraphFontSize && textVariant?.[generalParagraphFontSize] ? textVariant?.[generalParagraphFontSize] : textVariant?.['16'];
  const fontSizeCls = props?.pFontSize && textClasses?.[props?.pFontSize] ? textClasses?.[props?.pFontSize] :
  generalParagraphFontSize && textClasses?.[generalParagraphFontSize] ? textClasses?.[generalParagraphFontSize] : textClasses?.['16'];

  return (
    <Box
      color={descFontColor}
      {...props}
      >
      <Typography 
        variant={variant}
        className={fontSizeCls}
        style={{opacity:0.8,fontFamily:'inherit'}}
        dangerouslySetInnerHTML={props.description}
      />
      </Box>
  );
};

export {
  SectionTitle,
  SectionSubtitle,
  SectionParagraph
};

// export default SectionTitle;
